'use client';

import {useState} from 'react';

import {useKeypress} from '@utils/hooks/useKeypress';

import styles from './DesignGridDevOverlay.module.scss';

const times = (limit: number, iteratee: (index: number) => React.ReactNode) =>
  new Array(limit).fill(0).map((_, index) => iteratee(index));

const Modes = ['none', 'catalog', 'common'] as const;
type DisplayMode = (typeof Modes)[number];

/** вьюха для дебага, показывает полупрозрачные колонки новой сетки поверх контента */
export const DesignGridDevOverlay = () => {
  const [mode, setMode] = useState<DisplayMode>('none');
  useKeypress('G', () => {
    const currentIndex = Modes.indexOf(mode);
    const nextIndex = (currentIndex + 1) % Modes.length;
    setMode(Modes[nextIndex]);
  });

  if (mode === 'none') {
    return null;
  }
  if (mode === 'catalog') {
    return (
      <div className={styles.catalog}>
        {times(3, (columnIndex) => (
          <div key={columnIndex} className={styles.column} />
        ))}
      </div>
    );
  }
  return (
    <div className={styles.common}>
      {times(12, (columnIndex) => (
        <div key={columnIndex} className={styles.column} />
      ))}
    </div>
  );
};
